import { CodeBook } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils";

import { ProgramCodeBookExport } from "../../models/CodeBook/ProgramCodeBookExport";
import { ProgramCodeBook, EditProgramCodeBookRequest } from "../../models/Program";

const programUrlPrefix: string = "programs";

export const getPrograms = async () => {
  let result = await api.get(
    `${programUrlPrefix}/detail`
  ) as ProgramCodeBook[];
  setDatesPrograms(result);
  return result;
}

export const getProgramByName = async (name: CodeBook) => {
  let result = await api.get(
    `${programUrlPrefix}/by-name`,
    name
  ) as ProgramCodeBook;
  setDatesProgram(result);
  return result
}

export const createProgram = async (request: EditProgramCodeBookRequest) => {
  return api.post(
    `${programUrlPrefix}`,
    request
  ) as Promise<number>
}

export const editProgram = async (id: number, request: EditProgramCodeBookRequest) => {
  return api.put(
    `${programUrlPrefix}/${id}`,
    request
  ) as Promise<void>
}

export const deleteProgram = async (id: number) => {
  return api.delete(
    `${programUrlPrefix}/${id}`
  ) as Promise<void>
}

export const exportPrograms = async (request: ProgramCodeBookExport) => {
  var result = await (api.download(
    `${programUrlPrefix}/export`,
    "get",
    request
  ) as Promise<unknown>);
  return result
}

export const searchProgramNames = async(search: string) => {
  let request: any = {search: search}
  let url = `${programUrlPrefix}/search?search=${search}`;  
  return api.get(url, request) as Promise<CodeBook[]>;
}

export const searchProgramNamesV2 = async(search: string) => {
  let request: any = {search: search}
  let url = `${programUrlPrefix}/searchV2?search=${search}`;  
  return api.get(url, request) as Promise<CodeBook[]>;
}

const setDatesPrograms = (items: ProgramCodeBook[]) => {
  for (let item of items) {
    setDatesProgram(item);
  }
}

const setDatesProgram = (item: ProgramCodeBook) => {
  if (item.dateTo) {
    item.dateTo = new Date(item.dateTo);
  }
}